import { PaginateParams, SortDirection, useQuery } from './useQuery';
import axios from 'axios';
import { CacheId, useCache } from './useCache';
import { Cycle } from '../types/cycle.types';
import { CacheNames } from '../types/cache.enums';

type GetCycleResponse = Cycle;
type GetCyclesResponse = Array<Cycle>;
type GetCyclesParams = PaginateParams & {
  ids?: string[];
  // @deprecated
  with?: 'participants';
  courseId?: string;
  predecessorId?: string;
};

type Options = {
  fields?: Record<string, 1 | 0>;
  expandDates?: 1 | 0;
  sort?: Partial<Record<keyof Cycle, SortDirection>>;
  exists?: Partial<Record<keyof Cycle, 1 | 0>>;
};

const cacheName = CacheNames.CYCLES;

export function getCycle(
  cycleId: string,
  options: Options = {}
): Promise<GetCycleResponse> {
  const cacheId: CacheId = [cacheName, cycleId, options];
  const { result } = useQuery<GetCycleResponse>(cacheId, () =>
    axios
      .get<{ cycle: GetCycleResponse }>('/api/cycles/', {
        params: { id: cycleId, ...options },
      })
      .then((result) => result.data.cycle)
  );

  return result;
}

export function reloadCycle(
  cycleId: string,
  options: Options = {}
): Promise<GetCycleResponse> {
  useCache().clearCache(cacheName);

  return getCycle(cycleId, options);
}

export function getCycles(
  params: GetCyclesParams = {},
  options: Options = {}
): Promise<GetCyclesResponse> {
  const cacheId: CacheId = [cacheName, params, options];
  const mappedParams = {
    ...params,
    ...(params.ids && { ids: params.ids.join(',') }),
    ...options,
  };

  const { result } = useQuery<GetCyclesResponse>(cacheId, () =>
    axios
      .get<{ cycles: GetCyclesResponse }>('/api/cycles/', {
        params: mappedParams,
      })
      .then((result) => result.data.cycles)
  );

  return result;
}

export async function removeOutdatedCycles(): Promise<void> {
  const result = await axios.delete<void>('/api/cycles/outdated');

  useCache().clearCache(cacheName);

  return result.data;
}
